import { Helmet } from "react-helmet-async";

const SITE_URL = "https://elarahealth.life";

export interface Crumb {
  /** Visible label for this breadcrumb item */
  name: string;
  /** Site-relative path, e.g. "/peptides/weight-loss". Omit for the current page. */
  path?: string;
}

/**
 * Emits a schema.org BreadcrumbList for the current route.
 * "Home" is prepended automatically.
 */
export function BreadcrumbsJsonLd({ items }: { items: Crumb[] }) {
  const trail: Crumb[] = [{ name: "Home", path: "/" }, ...items];

  const json = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      ...(crumb.path ? { item: `${SITE_URL}${crumb.path}` } : {}),
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(json)}</script>
    </Helmet>
  );
}

export default BreadcrumbsJsonLd;
